import React from "react";
import {useBuildContractorQueryQuery} from "../../generated/graphql";
import {GraphQlSelect} from "./GraphQlSelect";

export const SiteBuildContractorSelect = (props) => {
    const query = useBuildContractorQueryQuery();
    return <GraphQlSelect {...props} queryResult={query} labelField="label"/>;
}